import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1d5878a9"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "heading text-center mb20" }, "検索0件ヒット", -1))
const _hoisted_2 = /*#__PURE__*/_createTextVNode("日付指定で検索")

import { useStore } from "vuex";
import { computed, onMounted, ref, watch } from 'vue'
import { Chart, ChartData, registerables, ChartOptions } from "chart.js";
import { BarChart } from "vue-chart-3";
import { QuestionSearchResultLogic } from "@/logic/question/QuestionSearchResultLogic";
import { GetListParams } from '@/repositories/QuestionSearchResultRepository'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

Chart.register(...registerables);
const { getList, questionSearchResults, questionSearchResultLoading, getCategoryList, categoryList } = QuestionSearchResultLogic();
const store = useStore();
// const managerFlg = computed(() => store.state.login.manager_flg);
const managerFlg = computed(() => store.state.login.manager_flg || store.state.login.project_owner_flg);
onMounted(async (): Promise<void> => {
  getList();
  await getCategoryList();
});
const options = computed<ChartOptions<'bar'>>(() => ({
  plugins: {
    legend: {
      align: 'end',
    },
  }
}));
const barData: ChartData<"bar"> = computed(() => {
  const label_array: string[] = []
  const values: number[] = []
  for (const result of questionSearchResults.value) {
    label_array.push(result.keyword)
    values.push(result.count)
  }
  return {
    labels: label_array,
    datasets: [
      {
        label: "検索0件ヒット",
        data: values,
        borderColor: "rgb(234, 82, 66, 0.7)",
        backgroundColor: "rgb(234, 82, 66, 0.7)",
      },
    ],
  }
});
const daterange = ref<Date[]>([]);
const categoryId = ref(0);
// const daterange = ref<string[]>([]);
const disabledDate = (time: Date) => {
  // nowDate = Date.now()
  let beforeTwoMonth = new Date
  beforeTwoMonth.setMonth(beforeTwoMonth.getMonth() - 2)
  if (time.getTime() < beforeTwoMonth.getTime()) {
    return true;
  }
  return time.getTime() > Date.now()
}
const rangeSearch = () => {
  if (daterange.value && daterange.value[0] && daterange.value[1]) {
    getList({
      start_date: daterange.value[0].toString(),
      end_date: daterange.value[1].toString(),
      question_category_id: categoryId.value
    });
  } else {
    getList();
  }
}
watch(categoryId, (newCategoryId) => {
  let params: GetListParams = {
    start_date: '',
    end_date: '',
    question_category_id: newCategoryId
  }
  if (daterange.value && daterange.value[0] && daterange.value[1]) {
    params['start_date'] = daterange.value[0].toString();
    params['end_date']   = daterange.value[1].toString();
  }

  getList(params);
});

return (_ctx: any,_cache: any) => {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_container = _resolveComponent("el-container")!
  const _directive_loading = _resolveDirective("loading")!

  return (_unref(managerFlg))
    ? (_openBlock(), _createBlock(_component_el_container, { key: 0 }, {
        default: _withCtx(() => [
          _createVNode(_component_el_main, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_card, { class: "box-card" }, {
                default: _withCtx(() => [
                  _hoisted_1,
                  _createVNode(_component_el_date_picker, {
                    modelValue: daterange.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((daterange).value = $event)),
                    type: "daterange",
                    "range-separator": "〜",
                    "start-placeholder": "開始日",
                    "end-placeholder": "終了日",
                    "value-format": "YYYY-MM-DD",
                    "disabled-date": disabledDate
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_el_button, {
                    type: "primary",
                    onClick: rangeSearch,
                    class: "align"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_2
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_select, {
                    modelValue: categoryId.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((categoryId).value = $event)),
                    class: "category-pulldown"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(categoryList), (category) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: category.id,
                          label: category.name,
                          value: category.id
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _withDirectives(_createElementVNode("div", null, [
                    _createVNode(_unref(BarChart), {
                      chartData: _unref(barData),
                      options: _unref(options)
                    }, null, 8, ["chartData", "options"])
                  ], 512), [
                    [_directive_loading, _unref(questionSearchResultLoading)]
                  ]),
                  _createVNode(_component_el_table, {
                    data: _unref(questionSearchResults),
                    stripe: "",
                    style: {"width":"100%"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_table_column, {
                        prop: "count",
                        label: "件数",
                        width: "65"
                      }),
                      _createVNode(_component_el_table_column, {
                        prop: "keyword",
                        label: "キーワード"
                      })
                    ]),
                    _: 1
                  }, 8, ["data"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})